import * as React from "react";

const AddAvatarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M21 17.4444C21 17.857 20.8276 18.2527 20.5207 18.5444C20.2138 18.8361 19.7976 19 19.3636 19H4.63636C4.20237 19 3.78616 18.8361 3.47928 18.5444C3.1724 18.2527 3 17.857 3 17.4444V8.88889C3 8.47633 3.1724 8.08067 3.47928 7.78894C3.78616 7.49722 4.20237 7.33333 4.63636 7.33333H7.90909L9.54545 5H14.4545L16.0909 7.33333H19.3636C19.7976 7.33333 20.2138 7.49722 20.5207 7.78894C20.8276 8.08067 21 8.47633 21 8.88889V17.4444Z"
      stroke="white"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z"
      stroke="white"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default AddAvatarIcon;
